import React from "react";
import avt1 from "../assets/avt1.jpg";
import avt2 from "../assets/avt2.webp";
import avt3 from "../assets/avt3.webp";
import avt4 from "../assets/avt4.jpg";

const Images = () => {
  const avatars = [avt1, avt2, avt3, avt4];

  return (
    <div className="flex items-center -space-x-3 sm:-space-x-4 md:-space-x-5 lg:-space-x-6
">
      {avatars.map((img, i) => (
        <div
          key={i}
          className="
            w-12 h-12
sm:w-12 sm:h-12
md:w-14 md:h-14
lg:w-16 lg:h-16
xl:w-18 xl:h-18

            rounded-full
            
            overflow-hidden
          
          "
        >
          <img
            src={img}
            alt="avatar"
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
};

export default Images;
